// extracted by mini-css-extract-plugin
module.exports = {"group":"az_Prb","actionCandidates":"az_Qrb","carousel":"az_Rrb","actionCandidatesTitle":"az_Srb","actionCandidatesContainer":"az_Trb"};